import { fetch } from '@biscuits/graphql';
import { createContext } from 'react';
import * as CONFIG from './config.js';
const LONG_PULL = 4 * 60 * 60 * 1000;
const SHORT_PULL = 45 * 1000;
export function getVerdantSync({ appId, initialPresence, access, dashboardMode, }) {
    return {
        initialPresence,
        defaultProfile: {
            id: '',
            name: 'Anonymous',
            imageUrl: null,
        },
        authEndpoint: `${CONFIG.API_ORIGIN}/verdant/token/${appId}?access=${access}`,
        useBroadcastChannel: true,
        fetch,
        pullInterval: dashboardMode ? LONG_PULL : SHORT_PULL,
    };
}
export const VerdantContext = createContext(null);
//# sourceMappingURL=verdant.js.map